<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <BlackListRegistry v-if="currentRoute === 'black-list'"></BlackListRegistry>
          <MDAListRegistry v-if="currentRoute === 'mda-list'"></MDAListRegistry>
          <DeRegistrationRegistry v-if="currentRoute === 'de-registration'"></DeRegistrationRegistry>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import BlackListRegistry from "@/domains/home/services/registry/business/BlackListRegistry.vue";
import MDAListRegistry from "@/domains/home/services/registry/business/MDAListRegistry.vue";
import DeRegistrationRegistry from "@/domains/home/services/registry/business/DeregistrationRegistry.vue";

const route = useRoute()

const currentRoute = ref("mda-list")

onMounted(() => {
  if (route.fullPath === "/home/non-individuals/business") {
    currentRoute.value = "black-list"
  } else if (route.fullPath === "/home/non-individuals/mda") {
    currentRoute.value = "mda-list"
  } else if (route.fullPath === "/home/non-individuals/de-registration") {
    currentRoute.value = "de-registration"
  }
})

const select = (route: string) => {
  currentRoute.value = route
}
</script>
